export const transformString = (x?: string) => (!x ? undefined : x.trim());

export default {};
